import { render, staticRenderFns } from "./CommitmentAttach.vue?vue&type=template&id=3bfe4f7d&"
import script from "./CommitmentAttach.vue?vue&type=script&lang=js&"
export * from "./CommitmentAttach.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentAttach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports